import { getStoreTimezone } from "./store-timezone";

function toDate(input: string | number | Date | null | undefined): Date | null {
  if (input == null) return null;
  const d = input instanceof Date ? input : new Date(input);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatBRDate(input: string | number | Date | null | undefined): string {
  const d = toDate(input);
  if (!d) return "—";
  return d.toLocaleDateString("pt-BR", { timeZone: getStoreTimezone() });
}

export function formatBRDateTime(input: string | number | Date | null | undefined): string {
  const d = toDate(input);
  if (!d) return "—";
  return d.toLocaleString("pt-BR", { timeZone: getStoreTimezone() });
}

export function formatBRDateTimeShort(input: string | number | Date | null | undefined): string {
  const d = toDate(input);
  if (!d) return "—";
  const date = d.toLocaleDateString("pt-BR", { timeZone: getStoreTimezone(), day: "2-digit", month: "2-digit" });
  const time = d.toLocaleTimeString("pt-BR", { timeZone: getStoreTimezone(), hour: "2-digit", minute: "2-digit" });
  return `${date} às ${time}`;
}

export function formatBRTime(input: string | number | Date | null | undefined): string {
  const d = toDate(input);
  if (!d) return "—";
  return d.toLocaleTimeString("pt-BR", { timeZone: getStoreTimezone(), hour: "2-digit", minute: "2-digit" });
}

export function brDayKey(input: string | number | Date | null | undefined): string {
  const d = toDate(input);
  if (!d) return "";
  return d.toLocaleDateString("en-CA", { timeZone: getStoreTimezone() });
}
